import {AppType} from './app';
import {AppCategory} from './category';

type PageNumber = `page-${number}`;

type Category = AppCategory['category'];

export type MainPageSlug =
  | undefined
  | [PageNumber | Category | Lowercase<AppType.GAMES>]
  | [Category | Lowercase<AppType.GAMES>, PageNumber]
  | [Lowercase<AppType.GAMES>, Category]
  | [Lowercase<AppType.GAMES>, Category, PageNumber];

export type MainPageOptions = {
  appType: AppType;
  category?: string;
  page: number;
};

export const NO_CATEGORY_CATEGORY = 'all';

export type NewMainPageOptions =
  | {
      type: 'selections';
      appType: AppType;
    }
  | {
      type: 'apps_list';
      appType: AppType;
      category?: string;
      page: number;
    }
  | {type: 'redirect'; to: string};
